import Swiper from "swiper";
import { Autoplay,FreeMode } from 'swiper/modules';
import AbstractComponent from "./abstract-component";

Swiper.use([FreeMode, Autoplay]);
  export default class Logos extends AbstractComponent {

    constructor(el) {
        super(el);
        this.DOM = {};
        this.sliderObjects = {};
        this.initDomElements();
        this.initSliders();
    }

    initDomElements() {
        this.DOM = {}
        this.DOM.sliderTop = this.$el.querySelector('.swiper-top')
        this.DOM.sliderBottom = this.$el.querySelector('.swiper-bottom')
        this.DOM.sliderMobile = this.$el.querySelector('.swiper-mobile')
        this.DOM.slides = this.$el.querySelectorAll('.swiper-slide')
        // Récupérer le nombre de lignes depuis l'attribut data
        this.numberOfLines = parseInt(this.$el.getAttribute('data-number-lines')) || 1
    }
    
    initSliders(){
        // Premier slider - défile de droite à gauche
        if (this.DOM.sliderTop) {
            this.sliderObjects.top = new Swiper(this.DOM.sliderTop, {
                loop: true,
                loopAdditionalSlides: 3,
                enabled: this.DOM.slides.length > 3,
                freeMode: {
                    enabled: true,
                },
                autoplay: {
                    enabled: true,
                    delay: 0,
                    pauseOnMouseEnter: true,
                    disableOnInteraction: false,
                },
                breakpoints:{
                    575.98:{
                        enabled: this.DOM.slides.length > 3,
                        loopAdditionalSlides: 1,
                    },
                    1189.98: {
                        enabled: this.DOM.slides.length > 6,  
                        loopAdditionalSlides: 1,
                    }
                },
                allowTouchMove: true,
                centeredSlides: false,
                slidesPerView: 'auto',
                speed: 5000,
            });
        }

        // Deuxième slider - défile de gauche à droite (direction opposée) - seulement si 2 lignes
        if (this.numberOfLines === 2 && this.DOM.sliderBottom) {
            this.sliderObjects.bottom = new Swiper(this.DOM.sliderBottom, {
                loop: true,
                enabled: this.DOM.slides.length > 3,
                loopAdditionalSlides: 3,
                freeMode: {
                    enabled: true,
                },
                autoplay: {
                    enabled: true,
                    delay: 0,
                    pauseOnMouseEnter: true,
                    disableOnInteraction: false,
                    reverseDirection: true, // Direction opposée
                },
                breakpoints:{
                    575.98:{
                        enabled: this.DOM.slides.length > 3,
                        loopAdditionalSlides: 1,
                    },
                    1189.98: {
                        enabled: this.DOM.slides.length > 6,  
                        loopAdditionalSlides: 1,
                    }
                },
                allowTouchMove: true,
                centeredSlides: false,
                slidesPerView: 'auto',
                speed: 5000,
            });
        }

        // Troisième slider mobile - même direction que le premier
        if (this.DOM.sliderMobile) {
            this.sliderObjects.mobile = new Swiper(this.DOM.sliderMobile, {
            loop: true,
            loopAdditionalSlides: 3,
            enabled: this.DOM.slides.length > 3,
            freeMode: {
                enabled: true,
            },
            autoplay: {
                enabled: true,
                delay: 0,
                pauseOnMouseEnter: true,
                disableOnInteraction: false,
            },
            breakpoints:{
                575.97: {
                    enabled: false, // Désactivé sur desktop
                }
            },
            allowTouchMove: true,
            centeredSlides: false,
            slidesPerView: 'auto',
            speed: 5000,
            });
        }
    }
    
    destroy() { 
        if (this.sliderObjects.top) {
            this.sliderObjects.top.destroy();
        }
        if (this.sliderObjects.bottom) {
            this.sliderObjects.bottom.destroy();
        }
        if (this.sliderObjects.mobile) {
            this.sliderObjects.mobile.destroy();
        }
    }
}